import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton, resolveRadius } from './Skeleton';
import { useTheme } from '../../theme';
const ASPECT_RATIO_MAP = {
    square: 100,
    '16:9': 56.25,
    '4:3': 75,
    '3:2': 66.6667,
};
export const ImageSkeleton = ({ aspectRatio = '16:9', width = '100%', height, animation = 'shimmer', radius, style, className, ...rest }) => {
    const theme = useTheme();
    const resolvedRadius = resolveRadius(radius ?? 'md', theme);
    const paddingBottom = ASPECT_RATIO_MAP[aspectRatio] ?? ASPECT_RATIO_MAP['16:9'];
    const containerStyle = {
        position: 'relative',
        width,
        ...(height ? { height } : { paddingBottom: `${paddingBottom}%` }),
        borderRadius: resolvedRadius,
        overflow: 'hidden',
        ...style,
    };
    const skeletonStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        borderRadius: 'inherit',
    };
    return (_jsx("div", { className: className, style: containerStyle, role: "status", "aria-label": "Loading image", ...rest, children: _jsx(Skeleton, { animation: animation, style: skeletonStyle }) }));
};
